import ReceiptScanner from './ReceiptScanner.vue';
import ReceiptScanLoader from './ReceiptScanLoader'
import FileInput from './FileInput'
import ImageDrawer from './ImageDrawer.vue';
import Erazer from './Erazer'
import Cropper from './Cropper'
import Zoomer from './Zoomer'

export {
  ReceiptScanner,
  ReceiptScanLoader,
  FileInput,
  ImageDrawer,
  Erazer,
  Cropper,
  Zoomer
};
